import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import { SparklesIcon } from "@heroicons/react/24/outline";
import { AssistantViewModel } from "../../viewmodels/assistant/AssistantViewModel";
import AssistantWorkspace from "../../components/forms/assistant/AssistantWorkspace";
import EmptyModal from "../../components/modals/EmptyModal";

function Assistant(props) {
  const { logout } = props;

  const {
    messages,
    conversations,
    activeConversationId,
    input,
    setInput,
    loading,
    historyLoading,
    canSend,
    sendMessage,
    handleKeyDown,
    listEndRef,
    inputRef,
    openConversation,
    startNewConversation,
    askDeleteConversation,
    emptyModal,
    setEmptyModelOpen,
  } = AssistantViewModel(logout);

  return (
    <div className="mt-2 lg:px-8 space-y-4">
      <div className="sm:flex sm:items-center px-4 py-5 card-custom">
        <div className="sm:flex-auto">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-soft">
                <SparklesIcon className="h-5 w-5 text-accent" />
              </div>
              <div>
                <h1 className="text-base font-semibold leading-6 text-gray-900">
                  AI Assistant
                </h1>
                <p className="text-sm text-gray-500">
                  The AI assistant can make mistakes. Double check important
                  information.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AssistantWorkspace
        messages={messages}
        conversations={conversations}
        activeConversationId={activeConversationId}
        input={input}
        setInput={setInput}
        loading={loading}
        historyLoading={historyLoading}
        canSend={canSend}
        sendMessage={sendMessage}
        handleKeyDown={handleKeyDown}
        listEndRef={listEndRef}
        inputRef={inputRef}
        openConversation={openConversation}
        startNewConversation={startNewConversation}
        askDeleteConversation={askDeleteConversation}
      />
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(actions.logout()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Assistant),
);
